import { Icon, Input, InputGroup, InputLeftElement, InputRightElement } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { BiSearch, BiX } from 'react-icons/bi';
import { useDebounce } from 'react-use';

export const SearchInput = ({
    initialValue = '',
    debounceCallback,
    focusRef,
    placeholder = 'Search by ID',
}: {
    initialValue?: string;
    debounceCallback: (value: string) => void;
    focusRef?: React.MutableRefObject<HTMLInputElement | null>;
    placeholder?: string;
}) => {
    const isMounted = useRef(false);
    const [searchString, setSearchString] = useState(initialValue);

    useEffect(() => {
        setSearchString(initialValue);
    }, [initialValue]);

    useDebounce(
        () => {
            if (isMounted.current) {
                debounceCallback(searchString);
            } else {
                isMounted.current = true;
            }
        },
        500,
        [searchString],
    );

    return (
        <InputGroup size="sm" width="100%">
            <InputLeftElement pointerEvents="none">
                <Icon as={BiSearch} />
            </InputLeftElement>
            <Input
                placeholder={placeholder}
                value={searchString}
                onChange={(ev) => setSearchString(ev.target.value)}
                ref={focusRef}
            />
            {searchString.length && (
                <InputRightElement
                    cursor="pointer"
                    onClick={() => setSearchString('')}
                    transitionProperty="common"
                    transitionDuration="normal"
                    _hover={{ backgroundColor: 'whiteAlpha.100' }}
                >
                    <Icon as={BiX} color="teal.300" />
                </InputRightElement>
            )}
        </InputGroup>
    );
};
